import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../common/theme/ISpcTheme';

export type StockCTAClasses = 'button';

const stockCTAStyles = makeStyles<ISpcTheme, StockCTAClasses>(
  () => ({
    button: {
      width: 'auto',
      border: 'none',
      textAlign: 'center',
      position: 'absolute',
      display: 'flex',
      borderRadius: '10px 10px 0 0',
      padding: '4px 12px 0px 12px',
      top: -21,
      right: 80,
      maxHeight: 21,
    },
  }),
  { name: 'Customise_StockCTA' },
);

export default stockCTAStyles;
